import { useState } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { Button, Col } from "react-bootstrap";
import NewInvitation from "../NewInvitation";
import AddPackagePop from "../../../Component/AddPackagePop";
import { deletePackage_, updatePackage_ } from "store/services/packageService";
import * as actions from "store/actions";
import { DELETE_ALERT, SUCCESS_MESSAGE } from "common/constantMessage";
import { useNavigate, useParams } from "react-router-dom";
import { myAccount } from "Routes/paths";
import { ReactComponent as DollarSign } from "Assets/Images/icn/dollarSign.svg";
import { formatPrice, getPackageSessionPrice } from "helpers/common";

const PackageInfoTab = ({ dispatch, packageDetails, getPackageDetails }) => {
  const { id: packageId } = useParams();
  const navigate = useNavigate();
  const [addPackagePop, setAddPackagePop] = useState(false);

  const editUpdatePackage = () => {
    try {
      setAddPackagePop(true);
    } catch (err) {
      console.log(err)
    }
  }

  const toggleAddPackagePop = () => {
    setAddPackagePop(!addPackagePop);
  };

  const submitData_ = async (values, { setSubmitting, resetForm }) => {
    try {
      setSubmitting(true);
      dispatch(actions.persist_store({ loader: true }));

      let response = await dispatch(updatePackage_(packageDetails.id, values));

      if (response && response.success === true && response.message) {
        SUCCESS_MESSAGE(response.message);
      }

      await getPackageDetails();

      setAddPackagePop(false);
      setSubmitting(false)
      dispatch(actions.persist_store({ loader: false }));
    } catch (err) {
      console.log(err, "==============================");
      setSubmitting(false);
      dispatch(actions.persist_store({ loader: false }));
    }
  };

  // delete package
  const deletePackage = async () => {
    try {
      await DELETE_ALERT().then(async (willDelete) => {
        if (willDelete) {
          dispatch(actions.persist_store({ loader: true }));
          await dispatch(deletePackage_(packageId));
          navigate(myAccount);
          dispatch(actions.persist_store({ loader: false }));
        }
      });
    } catch (err) {
      console.log("Error deleting package", err);
      dispatch(actions.persist_store({ loader: false }));
    }
  };

  return (
    <>
      <NewInvitation />
      <AddPackagePop
        addPackagePop={addPackagePop}
        toggleAddPackagePop={toggleAddPackagePop}
        submitData_={submitData_}
        currentPacakge={packageDetails}
      />
      <Col lg="12" md="12" className="my-2">
        <div className="commonCardBox MainCard" style={{ borderColor: "#FFCB86" }}>
          <div
            className="top px-lg-4 px-3 py-2 commonContent"
            style={{ background: "#f4694b" }}
          >
            <h3 className="m-0 text-white">Package Information</h3>
          </div>
          <div className="CardBody noLastBorder">
            <div className="PersonalInfo px-lg-4 px-3 py-3">
              <ul className="list-unstyled ps-0 mb-0">
                <li className="d-flex align-items-start gap-10 py-1">
                  <div className="left d-flex align-items-center w-25">
                    <span className="icn me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_0_4437)">
                          <path
                            d="M6.87025 6.852C7.73054 6.852 8.4754 6.54343 9.08419 5.93464C9.69277 5.32597 10.0014 4.58122 10.0014 3.72083C10.0014 2.8607 9.69287 2.11587 9.08408 1.50698C8.4753 0.89839 7.73044 0.589844 6.87025 0.589844C6.00984 0.589844 5.26506 0.89839 4.6564 1.50708C4.04774 2.11577 3.73906 2.86062 3.73906 3.72083C3.73906 4.58122 4.04771 5.32607 4.65643 5.93476C5.26529 6.54335 6.01015 6.852 6.87023 6.852H6.87025ZM5.19516 2.04574C5.6622 1.57868 6.2101 1.35166 6.87025 1.35166C7.53031 1.35166 8.07829 1.57868 8.54542 2.04574C9.01248 2.51288 9.2396 3.06085 9.2396 3.72081C9.2396 4.38096 9.01248 4.92886 8.54542 5.396C8.07829 5.86316 7.53031 6.09018 6.87025 6.09018C6.21028 6.09018 5.66243 5.86306 5.19516 5.396C4.728 4.92897 4.50088 4.38099 4.50088 3.72083C4.50088 3.06085 4.728 2.51288 5.19516 2.04574ZM12.349 10.5862C12.3314 10.3329 12.2959 10.0565 12.2436 9.76478C12.1909 9.47078 12.1229 9.19288 12.0416 8.93887C11.9575 8.67634 11.8433 8.4171 11.702 8.16863C11.5555 7.91076 11.3833 7.6862 11.1901 7.50144C10.9881 7.30814 10.7407 7.15272 10.4547 7.03933C10.1696 6.92659 9.85372 6.86947 9.51583 6.86947C9.38311 6.86947 9.25479 6.9239 9.00692 7.08529C8.83074 7.20001 8.65402 7.31393 8.47679 7.42704C8.3065 7.53556 8.0758 7.63723 7.79084 7.72927C7.51284 7.81923 7.23057 7.86485 6.95186 7.86485C6.67338 7.86485 6.39108 7.81923 6.11288 7.72927C5.82825 7.6373 5.59745 7.53566 5.42744 7.42714C5.23015 7.30108 5.05166 7.18604 4.89682 7.08516C4.64916 6.9238 4.52081 6.86934 4.38812 6.86934C4.0501 6.86934 3.73432 6.92657 3.44936 7.03946C3.16351 7.15262 2.91605 7.30804 2.71382 7.50154C2.52062 7.68641 2.34845 7.91084 2.20205 8.16863C2.06092 8.41707 1.94667 8.67623 1.86255 8.93898C1.7813 9.19298 1.71338 9.47078 1.66062 9.76478C1.60824 10.0562 1.57284 10.3326 1.55527 10.5865C1.53801 10.8347 1.5293 11.0931 1.5293 11.3542C1.5293 12.0328 1.74502 12.5821 2.17041 12.9873C2.59055 13.3871 3.14637 13.5898 3.82247 13.5898H10.0821C10.758 13.5898 11.3138 13.3871 11.734 12.9873C12.1595 12.5824 12.3752 12.0329 12.3752 11.3541C12.3751 11.0921 12.3663 10.8337 12.349 10.5862ZM11.2088 12.4353C10.9311 12.6995 10.5626 12.828 10.0819 12.828H3.8225C3.34178 12.828 2.97321 12.6995 2.69569 12.4355C2.42345 12.1763 2.29114 11.8225 2.29114 11.3542C2.29114 11.1106 2.29916 10.8701 2.31526 10.6392C2.3309 10.4126 2.36295 10.1638 2.41048 9.89935C2.45737 9.63821 2.51707 9.39314 2.58808 9.17127C2.65623 8.9585 2.74916 8.74786 2.86441 8.54494C2.9744 8.35151 3.10095 8.18559 3.2406 8.05191C3.37123 7.92683 3.53589 7.82448 3.72987 7.74773C3.90928 7.67668 4.11093 7.63781 4.32983 7.63195C4.35649 7.64616 4.40402 7.67323 4.48098 7.7234C4.63759 7.82547 4.81809 7.94191 5.01766 8.06935C5.24262 8.21278 5.5324 8.3423 5.87865 8.45407C6.23262 8.56853 6.59365 8.62665 6.95199 8.62665C7.31035 8.62665 7.67145 8.56853 8.02525 8.45417C8.37178 8.3422 8.66148 8.21278 8.88675 8.06915C9.09097 7.93864 9.26641 7.82557 9.423 7.7234C9.49998 7.67331 9.54749 7.64614 9.57417 7.63197C9.79317 7.63781 9.99479 7.67668 10.1743 7.7477C10.3682 7.82448 10.5329 7.92693 10.6635 8.05188C10.8031 8.18549 10.9297 8.35144 11.0397 8.54504C11.155 8.74786 11.2481 8.95863 11.3161 9.17117C11.3872 9.39334 11.447 9.63831 11.4938 9.89925C11.5412 10.1642 11.5734 10.4131 11.589 10.6393V10.6395C11.6052 10.8694 11.6133 11.1099 11.6134 11.3542C11.6133 11.8226 11.481 12.1763 11.2088 12.4353H11.2088Z"
                            fill="black"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_0_4437">
                            <rect
                              width="13"
                              height="13"
                              fill="white"
                              transform="translate(0.452148 0.589844)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    <p className="m-0 text-dark fw-bold">Name</p>
                  </div>
                  <div className="right w-75">
                    <p className="m-0">{packageDetails?.package_name}</p>
                  </div>
                </li>
                <li className="d-flex align-items-start gap-10 py-1">
                  <div className="left d-flex align-items-center w-25">
                    <span className="icn me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <path
                          d="M11.6775 3.05859H2.22699C1.6702 3.05859 1.21924 3.51235 1.21924 4.06635V10.1129C1.21924 10.6701 1.67351 11.1206 2.22699 11.1206H11.6775C12.2296 11.1206 12.6852 10.672 12.6852 10.1129V4.06635C12.6852 3.51334 12.236 3.05859 11.6775 3.05859ZM11.5363 3.73043L7.66482 7.58154C7.47446 7.77189 7.22141 7.8767 6.95222 7.8767C6.68304 7.8767 6.42999 7.77187 6.239 7.58091L2.36812 3.73043H11.5363ZM1.89107 9.97611V4.20351L4.79425 7.09139L1.89107 9.97611ZM2.36855 10.4488L5.27058 7.56519L5.76458 8.05659C6.08182 8.37383 6.5036 8.54853 6.95222 8.54853C7.40085 8.54853 7.82263 8.37383 8.13924 8.05722L8.63387 7.56519L11.5359 10.4488H2.36855ZM12.0134 9.97611L9.1102 7.09139L12.0134 4.20351V9.97611Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                    <p className="m-0 text-dark fw-bold">Price</p>
                  </div>
                  <div className="right w-75">
                    <p className="m-0">
                      {packageDetails.currency_sign}{formatPrice(packageDetails?.package_price)} ({packageDetails.currency_code})
                    </p>
                  </div>
                </li>
                <li className="d-flex align-items-start gap-10 py-1">
                  <div className="left d-flex align-items-center w-25">
                    <span className="icn me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <path
                          d="M11.6775 3.05859H2.22699C1.6702 3.05859 1.21924 3.51235 1.21924 4.06635V10.1129C1.21924 10.6701 1.67351 11.1206 2.22699 11.1206H11.6775C12.2296 11.1206 12.6852 10.672 12.6852 10.1129V4.06635C12.6852 3.51334 12.236 3.05859 11.6775 3.05859ZM11.5363 3.73043L7.66482 7.58154C7.47446 7.77189 7.22141 7.8767 6.95222 7.8767C6.68304 7.8767 6.42999 7.77187 6.239 7.58091L2.36812 3.73043H11.5363ZM1.89107 9.97611V4.20351L4.79425 7.09139L1.89107 9.97611ZM2.36855 10.4488L5.27058 7.56519L5.76458 8.05659C6.08182 8.37383 6.5036 8.54853 6.95222 8.54853C7.40085 8.54853 7.82263 8.37383 8.13924 8.05722L8.63387 7.56519L11.5359 10.4488H2.36855ZM12.0134 9.97611L9.1102 7.09139L12.0134 4.20351V9.97611Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                    <p className="m-0 text-dark fw-bold">Price per session</p>
                  </div>
                  <div className="right w-75">
                    <p className="m-0">
                   {packageDetails.currency_sign}{getPackageSessionPrice(packageDetails?.package_price, packageDetails?.session_count)} ({packageDetails.currency_code})/session
                    </p>
                  </div>
                </li>
                <li className="d-flex align-items-start gap-10 py-1">
                  <div className="left d-flex align-items-center w-25">
                    <span className="icn me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_0_4433)">
                          <path
                            d="M6.95215 0.589844C4.4704 0.589844 2.45215 2.60809 2.45215 5.08984C2.45215 8.20909 6.51415 12.3071 6.68665 12.4803C6.75721 12.5505 6.85266 12.5898 6.95215 12.5898C7.05164 12.5898 7.14708 12.5505 7.21765 12.4803C7.39015 12.3071 11.4521 8.20909 11.4521 5.08984C11.4521 2.60809 9.4339 0.589844 6.95215 0.589844ZM6.95215 11.6726C6.05665 10.7141 3.20215 7.47259 3.20215 5.08984C3.20215 3.02209 4.8844 1.33984 6.95215 1.33984C9.0199 1.33984 10.7021 3.02209 10.7021 5.08984C10.7021 7.47034 7.84765 10.7141 6.95215 11.6726Z"
                            fill="black"
                          />
                          <path
                            d="M6.95215 2.83984C5.71165 2.83984 4.70215 3.84934 4.70215 5.08984C4.70215 6.33034 5.71165 7.33984 6.95215 7.33984C8.19265 7.33984 9.20215 6.33034 9.20215 5.08984C9.20215 3.84934 8.19265 2.83984 6.95215 2.83984ZM6.95215 6.58984C6.1249 6.58984 5.45215 5.91709 5.45215 5.08984C5.45215 4.26259 6.1249 3.58984 6.95215 3.58984C7.7794 3.58984 8.45215 4.26259 8.45215 5.08984C8.45215 5.91709 7.7794 6.58984 6.95215 6.58984Z"
                            fill="black"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_0_4433">
                            <rect
                              width="12"
                              height="12"
                              fill="white"
                              transform="translate(0.952148 0.589844)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    <p className="m-0 text-dark fw-bold">Description</p>
                  </div>
                  <div className="right w-75">
                    <p className="m-0 is-multiline">
                      {packageDetails?.package_desc}
                    </p>
                  </div>
                </li>
                <li className="d-flex align-items-start gap-10 py-1">
                  <div className="left d-flex align-items-center w-25">
                    <span className="icn me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <path
                          d="M11.4209 3.06055H10.6084V2.6543C10.6084 2.2062 10.244 1.8418 9.7959 1.8418H8.9834C8.5353 1.8418 8.1709 2.2062 8.1709 2.6543V3.06055H5.7334V2.6543C5.7334 2.2062 5.36899 1.8418 4.9209 1.8418H4.1084C3.6603 1.8418 3.2959 2.2062 3.2959 2.6543V3.06055H2.4834C1.81136 3.06055 1.26465 3.60726 1.26465 4.2793V11.1855C1.26465 11.8576 1.81136 12.4043 2.4834 12.4043H11.4209C12.0929 12.4043 12.6396 11.8576 12.6396 11.1855V4.2793C12.6396 3.60726 12.0929 3.06055 11.4209 3.06055ZM8.9834 2.6543H9.7959V4.2793H8.9834V2.6543ZM4.1084 2.6543H4.9209V4.2793H4.1084V2.6543ZM11.8271 11.1855C11.8271 11.4095 11.6448 11.5918 11.4209 11.5918H2.4834C2.25945 11.5918 2.07715 11.4095 2.07715 11.1855V6.7168H11.8271V11.1855ZM11.8271 5.9043H2.07715V4.2793C2.07715 4.05535 2.25945 3.87305 2.4834 3.87305H3.2959V4.2793C3.2959 4.72739 3.6603 5.0918 4.1084 5.0918H4.9209C5.36899 5.0918 5.7334 4.72739 5.7334 4.2793V3.87305H8.1709V4.2793C8.1709 4.72739 8.5353 5.0918 8.9834 5.0918H9.7959C10.244 5.0918 10.6084 4.72739 10.6084 4.2793V3.87305H11.4209C11.6448 3.87305 11.8271 4.05535 11.8271 4.2793V5.9043ZM3.2959 8.3418C3.2959 8.23405 3.3387 8.13072 3.41489 8.05453C3.49107 7.97835 3.5944 7.93555 3.70215 7.93555H4.51465C4.62239 7.93555 4.72572 7.97835 4.80191 8.05453C4.8781 8.13072 4.9209 8.23405 4.9209 8.3418C4.9209 8.44954 4.8781 8.55287 4.80191 8.62906C4.72572 8.70525 4.62239 8.74805 4.51465 8.74805H3.70215C3.5944 8.74805 3.49107 8.70525 3.41489 8.62906C3.3387 8.55287 3.2959 8.44954 3.2959 8.3418ZM3.2959 9.9668C3.2959 9.85905 3.3387 9.75572 3.41489 9.67953C3.49107 9.60335 3.5944 9.56055 3.70215 9.56055H4.51465C4.62239 9.56055 4.72572 9.60335 4.80191 9.67953C4.8781 9.75572 4.9209 9.85905 4.9209 9.9668C4.9209 10.0745 4.8781 10.1779 4.80191 10.2541C4.72572 10.3302 4.62239 10.373 4.51465 10.373H3.70215C3.5944 10.373 3.49107 10.3302 3.41489 10.2541C3.3387 10.1779 3.2959 10.0745 3.2959 9.9668ZM6.13965 8.3418C6.13965 8.23405 6.18245 8.13072 6.25864 8.05453C6.33482 7.97835 6.43815 7.93555 6.5459 7.93555H7.3584C7.46614 7.93555 7.56947 7.97835 7.64566 8.05453C7.72185 8.13072 7.76465 8.23405 7.76465 8.3418C7.76465 8.44954 7.72185 8.55287 7.64566 8.62906C7.56947 8.70525 7.46614 8.74805 7.3584 8.74805H6.5459C6.43815 8.74805 6.33482 8.70525 6.25864 8.62906C6.18245 8.55287 6.13965 8.44954 6.13965 8.3418ZM6.13965 9.9668C6.13965 9.85905 6.18245 9.75572 6.25864 9.67953C6.33482 9.60335 6.43815 9.56055 6.5459 9.56055H7.3584C7.46614 9.56055 7.56947 9.60335 7.64566 9.67953C7.72185 9.75572 7.76465 9.85905 7.76465 9.9668C7.76465 10.0745 7.72185 10.1779 7.64566 10.2541C7.56947 10.3302 7.46614 10.373 7.3584 10.373H6.5459C6.43815 10.373 6.33482 10.3302 6.25864 10.2541C6.18245 10.1779 6.13965 10.0745 6.13965 9.9668ZM8.9834 8.3418C8.9834 8.23405 9.0262 8.13072 9.10239 8.05453C9.17857 7.97835 9.2819 7.93555 9.38965 7.93555H10.2021C10.3099 7.93555 10.4132 7.97835 10.4894 8.05453C10.5656 8.13072 10.6084 8.23405 10.6084 8.3418C10.6084 8.44954 10.5656 8.55287 10.4894 8.62906C10.4132 8.70525 10.3099 8.74805 10.2021 8.74805H9.38965C9.2819 8.74805 9.17857 8.70525 9.10239 8.62906C9.0262 8.55287 8.9834 8.44954 8.9834 8.3418ZM8.9834 9.9668C8.9834 9.85905 9.0262 9.75572 9.10239 9.67953C9.17857 9.60335 9.2819 9.56055 9.38965 9.56055H10.2021C10.3099 9.56055 10.4132 9.60335 10.4894 9.67953C10.5656 9.75572 10.6084 9.85905 10.6084 9.9668C10.6084 10.0745 10.5656 10.1779 10.4894 10.2541C10.4132 10.3302 10.3099 10.373 10.2021 10.373H9.38965C9.2819 10.373 9.17857 10.3302 9.10239 10.2541C9.0262 10.1779 8.9834 10.0745 8.9834 9.9668Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                    <p className="m-0 text-dark fw-bold">Date</p>
                  </div>
                  <div className="right w-75">
                    <p className="m-0">
                      {moment(packageDetails?.created_at).format("MMM DD, YYYY")}
                    </p>
                  </div>
                </li>
              </ul>
              <div className="mt-3 btmWrp d-flex gap-10">
                <Button
                  onClick={editUpdatePackage}
                  className="d-flex align-items-center justify-content-center commonBtn btnSm"
                >
                  Edit Package Information
                </Button>
                <Button
                  onClick={deletePackage}
                  className="d-flex align-items-center justify-content-center commonBtn btnSm"
                >
                  Delete Package
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Col>
    </>
  )
}

const mapStateToPros = (state) => {
  return {
  };
};
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(PackageInfoTab);
